<form [formGroup]="exitForm">
    <mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'asset-fund-investment'" [commentSlug]="'exits'">
        <mat-card-header class="detail-card-header">
            <mat-card-title data-test="title">Investment & Exit Dates</mat-card-title>
        </mat-card-header>

        @let assetValuation = (assetValuation$ | async);
        @let fundInvestment = (fundInvestment$ | async);
        @if (!!fundInvestment && fundInvestment.data.id) {
            <mat-card-subtitle>
                @if (fundInvestment.status === 'ERROR') {
                    <valumize-info-panel [appearance]="'ERROR'"
                                         [message]="fundInvestment.errorMessage"></valumize-info-panel>
                }
                @if (fundInvestment.status === 'SAVED') {
                    <valumize-info-panel [appearance]="'SAVED'"
                                         [message]="'Investment & Exit Date successfully saved'"></valumize-info-panel>
                }
                <!-- The transaction summary saves through its own endpoint, so it reports separately.
                     Its failure no longer blanks the record, which means the shared status above stays
                     SAVED for the realization half — the two halves of one click can now disagree, and
                     saying so is better than the old behaviour of showing only one of them. -->
                @if (transactionSummarySaveState$ | async; as summarySaveState) {
                    @if (summarySaveState.status === 'ERROR') {
                        <valumize-info-panel [appearance]="'ERROR'"
                                             [message]="'Transaction Summary: ' + summarySaveState.errorMessage"></valumize-info-panel>
                    }
                }
                @if (fundInvestment.status === 'LOADING') {
                    <mat-progress-spinner></mat-progress-spinner>
                }
                @if (warningMessage) {
                    <valumize-info-panel [appearance]="'WARNING'"
                                         [message]="warningMessage"
                                         [closable]="true" (closePanel)="closeWarning()"></valumize-info-panel>
                }
            </mat-card-subtitle>
            <mat-card-content class="detail-card-content">
                <div class="key-value-pair-section">
                    <div class="key-value-pair-column">
                        <valumize-mergeable-date
                            [label]="'Investment Date'"
                            [isEditable]=exitIsEditable
                            [isDataset]=isDataset
                            [value]=fundInvestment.data.investmentDate
                            [baselineValue]=baselineFundInvestment.investmentDate
                            [control]=exitForm.controls.entryDate
                            [isMandatory]="false">
                        </valumize-mergeable-date>
                        @if (assetValuation) {
                            <div class="key-value-pair">
                                <div class="key-value-item">Exit Date Assumption</div>
                                <div class="key-value-item">{{ assetValuation.exitDateAssumption.date | date }}</div>
                            </div>
                        }
                        <valumize-mergeable-checkbox
                            [label]="'Realized'"
                            [isEditable]=exitIsEditable
                            [isDataset]=isDataset
                            [value]="fundInvestment.data.isRealized.value ?? false"
                            [baselineValue]="baselineFundInvestment.isRealized.value ?? false"
                            [control]=exitForm.controls.isRealized>
                        </valumize-mergeable-checkbox>
                        <valumize-mergeable-date
                            [label]="'Effective Exit Date'"
                            [isEditable]=exitIsEditable
                            [isDataset]=isDataset
                            [value]=fundInvestment.data.exitDate
                            [baselineValue]=baselineFundInvestment.exitDate
                            [control]=exitForm.controls.effectiveExitDate
                            [isMandatory]="false">
                        </valumize-mergeable-date>
                    </div>
                    <div class="key-value-pair-column" [formGroup]="transactionSummaryForm">
                        <div class="key-value-pair-column-title">Transaction Summary</div>
                        @if (transactionSummary$ | async; as transactionSummary) {
                            @if (!exitIsEditable && transactionSummary.text) {
                                <div class="line-breaks">{{ transactionSummary.text }}</div>
                            }
                            @if (!exitIsEditable && !transactionSummary.text) {
                                <div class="no-text" style="color: grey">No transaction summary recorded yet.</div>
                            }
                            @if (exitIsEditable) {
                                <mat-form-field class="description">
                                    <textarea class="line-breaks" formControlName="text" data-test="transaction-summary-text" matInput></textarea>
                                </mat-form-field>
                            }
                        }
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="detail-card-actions">
                <div class="last-modified" data-test="modification-date">Last modified: {{ mostRecentModDate | timestamp }}</div>
                <valumize-card-comments-button [commentScope]="'asset-fund-investment'" [commentSlug]="'exits'"></valumize-card-comments-button>
                @if (!exitIsEditable) {
                    <button (click)="editMode()" [disabled]="(isEditDisabled$ | async)!" color="primary" data-test="edit-button" mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @let assetId = (assetId$ | async);
                @let fund = (relatedFund$ | async);
                @let fundId = fund?.id;
                @let fundReportId = (fundReportId$ | async);
                @if (assetId && fundId && fundReportId && exitIsEditable) {
                    <button (click)="save()"
                            [disabled]="exitForm.invalid"
                            color="primary"
                            data-test="save-button"
                            mat-icon-button>
                        <mat-icon>save</mat-icon>
                    </button>
                }
                @if (exitIsEditable) {
                    <button (click)="cancel()" color="primary" data-test="cancel-button" mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
            </mat-card-actions>
        } @else {
            <mat-card-content class="detail-card-content" style="color: grey">
                Investment & Exit Dates are only available after the asset is assigned to a fund.
            </mat-card-content>
        }
    </mat-card>
</form>

